//pageview facebook
const idEvent = Date.now();

if (!getCookie('publicIp') || getCookie('publicIp').split('=').length <= 1) {
  jQuery.get(
    drupalSettings.facebookApiConverter.facebookUrlIp,
    function (data) {
      createCookieWithValue('publicIp', data, 60);
      if (
        drupalSettings &&
        drupalSettings.facebookApiConverter &&
        drupalSettings.facebookApiConverter.facebook_pixel_2
      ) {
        fbq('init', drupalSettings.facebookApiConverter.facebook_pixel_2, {
          external_id: idEvent,
          client_ip_address: data,
        });
        fbq('init', drupalSettings.facebookApiConverter.facebook_pixel_1, {
          external_id: idEvent,
          client_ip_address: data,
        });
        fbq(
          'trackSingle',
          drupalSettings.facebookApiConverter.facebook_pixel_2,
          'PageView',
          {},
          { eventID: 'PageView.' + idEvent },
        );
        fbq(
          'trackSingle',
          drupalSettings.facebookApiConverter.facebook_pixel_1,
          'PageView',
          {},
          { eventID: 'PageView.' + idEvent },
        );
      }
    },
  );
} else if (
  drupalSettings &&
  drupalSettings.facebookApiConverter &&
  drupalSettings.facebookApiConverter.facebook_pixel_2
) {
  fbq('init', drupalSettings.facebookApiConverter.facebook_pixel_2, {
    external_id: idEvent,
    client_ip_address: getCookie('publicIp').split('=')[1],
  });
  fbq('init', drupalSettings.facebookApiConverter.facebook_pixel_1, {
    external_id: idEvent,
    client_ip_address: getCookie('publicIp').split('=')[1],
  });
  fbq(
    'trackSingle',
    drupalSettings.facebookApiConverter.facebook_pixel_2,
    'PageView',
    {},
    { eventID: 'PageView.' + idEvent },
  );
  fbq(
    'trackSingle',
    drupalSettings.facebookApiConverter.facebook_pixel_1,
    'PageView',
    {},
    { eventID: 'PageView.' + idEvent },
  );
}

function sendFacebookApiTracking(
  eventName,
  pixelId,
  pixelNum,
  clientIp,
  externalId,
  fbc = '',
  fbp = '',
) {
  if (drupalSettings.facebookApiConverter.facebookTrackingEnabled) {
    const time = Math.floor(new Date().getTime() / 1000);
    const request = {
      data: [
        {
          event_id: eventName + '.' + time,
          event_name: eventName,
          event_time: time,
          event_source_url: window.location.href,
          action_source: 'website',
          user_data: {
            external_id: externalId,
            fbc,
            fbp,
            client_user_agent: navigator.userAgent,
            client_ip_address: clientIp,
          },
        },
      ],
    };
    if (
      drupalSettings.facebookApiConverter &&
      drupalSettings.facebookApiConverter.test_mode &&
      drupalSettings.facebookApiConverter['test_code_pixel_' + pixelNum]
    ) {
      request['test_event_code'] =
        drupalSettings.facebookApiConverter['test_code_pixel_' + pixelNum];
    }
    const uri =
      drupalSettings.facebookApiConverter.facebookApiBaseUrl +
      'v' +
      drupalSettings.facebookApiConverter.version +
      '/' +
      pixelId +
      '/events?access_token=' +
      drupalSettings.facebookApiConverter['token_pixel_' + pixelNum];
    callApi({ uri, method: 'POST', data: request });
  }
}
